const PAGES = {
  HOME: 'HOME',
  ADDRESSES: 'ADDRESSES',
  DRAW: 'DRAW',
  ESTABLISHMENTS: 'ESTABLISHMENTS',
  CADASTRAL_OBJECTS: 'CADASTRAL_OBJECTS',
  CADASTRAL_SUBJECTS: 'CADASTRAL_SUBJECTS',
  MONUMENTEN: 'MONUMENTEN',
  OPENBARE_RUIMTEN: 'OPENBARE_RUIMTEN',
  WOONPLAATSEN: 'WOONPLAATSEN',
  PANDEN: 'PANDEN',
  PANORAMA: 'PANORAMA',

  CATALOG_OVERVIEW: 'CATALOG_OVERVIEW',
  CATALOG_DETAIL: 'CATALOG_DETAIL',

  CONSTRUCTION_DOSSIER: 'CONSTRUCTION_DOSSIER',
  CONSTRUCTION_DOSSIER_LIST: 'CONSTRUCTION_DOSSIER_LIST',

  DATA: 'DATA',
  DATA_DETAIL: 'DATA_DETAIL',
  DATA_SEARCH_GEO: 'DATA_SEARCH_GEO',
  DATA_SEARCH_CATEGORY: 'SEARCH_DATA_CATEGORY',

  GLOSSARY_DETAIL: 'GLOSSARY_DETAIL',
  GLOSSARY_OVERVIEW: 'GLOSSARY_OVERVIEW',

  SEARCH: 'SEARCH',
  ONE_DESIGN: 'ONE_DESIGN',

  // text pages
  HELP: 'HELP',
  NOT_FOUND: 'NOT_FOUND',
  ABOUT: 'ABOUT',
  ABOUT_WEBSITE: 'ABOUT_WEBSITE',
  CONTACT: 'CONTACT',
  DATA_CONTACT: 'DATA_CONTACT',
  ACCESSIBILITY: 'ACCESSIBILITY',
  TECHNICAL_MANAGEMENT: 'TECHNICAL_MANAGEMENT',
  QUALITY: 'QUALITY',
  FAQ: 'FAQ',
  FEATURES: 'FEATURES',
  SERVICES: 'SERVICES',
  TABLES: 'TABLES',
  EMPLOYEES: 'EMPLOYEES',
  MAP_LAYERS_INFO: 'MAP_LAYERS_INFO',
  UNDERGROUND_DOSSIER: 'UNDERGROUND_DOSSIER',
  // underground Dossier static pages
  AMSTERDAM_UNDERGROND: 'AMSTERDAM_UNDERGROND',
  ARCHIVE_MAP_HISTORIC: 'ARCHIVE_MAP_HISTORIC',
  BRO_PILOT_3D_MODEL: 'BRO_PILOT_3D_MODEL',
  ENVIRONMENT_SOIL_QUALITY: 'ENVIRONMENT_SOIL_QUALITY',
  ENVIRONMENT_SOIL_COMPOSITION: 'ENVIRONMENT_SOIL_COMPOSITION',
  GROUND_WATER: 'GROUND_WATER',
  DIKES: 'DIKES',
  CLIMATE: 'CLIMATE',
  ARCHEOLOGY: 'ARCHEOLOGY',
  CABLES_PIPES: 'CABLES_PIPES',
  ENERGY: 'ENERGY',
  TREES_GREENS: 'TREES_GREENS',
  JAPANESE_TREE: 'JAPANESE_TREE',
  UNDERGROUND_OBJECTS: 'UNDERGROUND_OBJECTS',
  UNDERGROUND_SPACE: 'UNDERGROUND_SPACE',
  UNDERGROUND_MOBILITY: 'UNDERGROUND_MOBILITY',
  // dataplatform services pages
  DATA_PLATFORM_SERVICES: 'DATA_PLATFORM_SERVICES',
  MAP_LAYER_DETAIL: 'MAP_LAYER_DETAIL',
  INTERACTIVE_TABLES_DETAIL: 'INTERACTIVE_TABLES_DETAIL',
  DATASET_CATALOG_DETAIL: 'DATASET_CATALOG_DETAIL',
  DATA_PROCESSING_DETAIL: 'DATA_PROCESSING_DETAIL',
  COMPLIANCY_AUDIT: 'COMPLIANCY_AUDIT',
  STANDARDISED_INFORMATION_SERVICES: 'STANDARDISED_INFORMATION_SERVICES',
  ANALYSE_SUITE: 'ANALYSE_SUITE',
}

export default PAGES

export const isContentPage = (page: string) =>
  page === PAGES.NOT_FOUND ||
  page === PAGES.HELP ||
  page === PAGES.ABOUT ||
  page === PAGES.ABOUT_WEBSITE ||
  page === PAGES.DATA_PLATFORM_SERVICES ||
  page === PAGES.DATASET_CATALOG_DETAIL ||
  page === PAGES.DATA_PROCESSING_DETAIL ||
  page === PAGES.COMPLIANCY_AUDIT ||
  page === PAGES.STANDARDISED_INFORMATION_SERVICES ||
  page === PAGES.ANALYSE_SUITE ||
  page === PAGES.CONTACT ||
  page === PAGES.DATA_CONTACT ||
  page === PAGES.ACCESSIBILITY ||
  page === PAGES.TECHNICAL_MANAGEMENT ||
  page === PAGES.QUALITY ||
  page === PAGES.FAQ ||
  page === PAGES.FEATURES ||
  page === PAGES.GLOSSARY_OVERVIEW ||
  page === PAGES.GLOSSARY_DETAIL ||
  page === PAGES.SERVICES ||
  page === PAGES.TABLES ||
  page === PAGES.EMPLOYEES ||
  page === PAGES.MAP_LAYERS_INFO ||
  page === PAGES.MAP_LAYER_DETAIL ||
  page === PAGES.INTERACTIVE_TABLES_DETAIL ||
  page === PAGES.UNDERGROUND_DOSSIER ||
  page === PAGES.AMSTERDAM_UNDERGROND ||
  page === PAGES.ARCHIVE_MAP_HISTORIC ||
  page === PAGES.BRO_PILOT_3D_MODEL ||
  page === PAGES.ENVIRONMENT_SOIL_QUALITY ||
  page === PAGES.ENVIRONMENT_SOIL_COMPOSITION ||
  page === PAGES.GROUND_WATER ||
  page === PAGES.DIKES ||
  page === PAGES.CLIMATE ||
  page === PAGES.ARCHEOLOGY ||
  page === PAGES.CABLES_PIPES ||
  page === PAGES.ENERGY ||
  page === PAGES.TREES_GREENS ||
  page === PAGES.JAPANESE_TREE ||
  page === PAGES.UNDERGROUND_OBJECTS ||
  page === PAGES.UNDERGROUND_SPACE ||
  page === PAGES.UNDERGROUND_MOBILITY ||
  page === PAGES.CATALOG_OVERVIEW ||
  page === PAGES.CATALOG_DETAIL

export const isSearchPage = (page: string) =>
  page === PAGES.SEARCH || page === PAGES.CONSTRUCTION_DOSSIER_LIST

export const isDataplatformServicesPage = (page: string) => page === PAGES.DATA_PLATFORM_SERVICES
